
const Footer = () => (
  <footer style={{ background: '#eee', textAlign: 'center', padding: '1rem', marginTop: '2rem' }}>
    <p>&copy; {new Date().getFullYear()} Pluto Loans · All rights reserved.</p>
  </footer>
);

export default Footer;
